import { getHomeCompany } from "actions/Utilities/HomeCompany";
import { useQuery } from "react-query";

export default function useGetHomeCompany() {
  return useQuery(
    "GetHomeCompany",
    getHomeCompany,
    {
      refetchOnWindowFocus: false,
    }
  );
}
